/**
 * Utility helpers for waste profile ID operations across tote items.
 * Returns the intersection of multiple string arrays.
 * i.e. only IDs that appear in EVERY array are kept.
 */
export function intersection(arrays: string[][]): string[] {
    if (arrays.length === 0) return [];
    return arrays.reduce((acc, curr) =>
        acc.filter((id) => curr.includes(id))
    );
}

/**
 * Given a list of selected ToteItems, returns the intersection of their
 * waste profile IDs.
 *
 * Returns [] if any item has no profileIds (no common containers possible).
 */
export function getWasteProfileIntersection(
    items: Array<{ profileIds?: string[] }>
): string[] {
    if (items.length === 0) return [];
    return intersection(items.map((item) => item.profileIds ?? []));
}

/**
 * Given a list of selected ToteItems, returns the intersection of their
 * recommended donation category IDs. Used for the DONATION container search.
 */
export function getDonationCategoryIntersection(
    items: Array<{ recommendedCategories?: Array<{ id: string }> }>
): string[] {
    if (items.length === 0) return [];
    return intersection(
        items.map((item) => (item.recommendedCategories ?? []).map((c) => c.id))
    );
}
